import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dialog"
export default class extends Controller {
  static targets = ["dialog", "openButton"];
  static values = {
    animation: { type: Boolean, default: false },
    animationClass: { type: String, default: "animate-tada" },
  };

  open() {
    this.dialogTarget.showModal();
    if (this.animationValue) {
      this.dialogTarget.classList.add(this.animationClassValue);
    }
  }

  close() {
    this.dialogTarget.close();
    if (this.animationValue) {
      this.dialogTarget.classList.remove(this.animationClassValue);
    }
  }
}
